import { preloadSearchPage } from '#pplx/frontend/apps/ask/page-components/search/search-page-loader.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const loadSearchComponents = async () => {
    const searchComponentsPromise = import('#pplx/frontend/apps/ask/page-components/search/search-components.js');
    void preloadSearchPage();
    const { SearchComponents } = await searchComponentsPromise;
    return { default: SearchComponents };
};
const SearchComponentsPreloader = Dynamic(loadSearchComponents);
export const preloadSearchComponent = SearchComponentsPreloader.preload;
//# sourceMappingURL=SearchComponentsRouteShared.js.map